export const SUPPORT_EMAIL = 'support@parkingbolt.com'
export const PRIVACY_EMAIL = 'privacy@parkingbolt.com'
export const COMPANY_NAME = 'SAS NEXIAMOBILE'
export const BRAND_NAME = 'ParkingBolt'
export const WEBSITE_URL = 'parkingbolt.com'

export const SUPPORT_PHONE = '+1 (229) 530-2299'
export const SUPPORT_PHONE_TEL = '+12295302299'
export const SUPPORT_HOURS = 'Monday to Friday, 9:00 AM – 6:00 PM (GMT-10)'

// Identification légale (Kbis RCS Papeete, à jour au 04/06/2026)
export const COMPANY_LEGAL_FORM = 'Société par actions simplifiée (SAS)'
export const COMPANY_CAPITAL = '200 000 F CFP (XPF)'
export const COMPANY_RCS = 'R.C.S. Papeete 26 108 B'
export const COMPANY_TAHITI_NUMBER = 'N° Tahiti G50512'
export const COMPANY_ADDRESS_LINE1 = 'Lotissement Tamahana, lot n°52'
export const COMPANY_ADDRESS_LINE2 = '98701 Arue, French Polynesia'
export const COMPANY_DIRECTOR = 'Pierre Alexandre Germon (Président)'

export const HOSTING_PROVIDER = 'Netlify, Inc. — 512 2nd Street, Suite 200, San Francisco, CA 94107, USA — www.netlify.com'
